import { Link } from "react-router-dom";
import { FDA } from "@/data/content";
import { NAV } from "@/components/Header";
import { SocialLinks } from "@/components/Social";
import { useStore } from "@/context/StoreContext";
import { openCookieSettings } from "@/components/CookieBanner";
import { WelcomeSignup } from "@/components/WelcomeSignup";

const POLICY_LINKS = [
  { to: "/policies/shipping", label: "Shipping" },
  { to: "/refund-policy", label: "Refunds" },
  { to: "/privacy", label: "Privacy" },
  { to: "/policies/terms", label: "Terms" },
  { to: "/account#subscriptions", label: "Cancel a subscription" },
];

const Col = ({ title, links, extra }) => (
  <div>
    <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-foam">{title}</p>
    <ul className="mt-4 space-y-2">
      {links.map((l) => (
        <li key={l.to}><Link to={l.to} data-testid={`footer-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}-link`} className="text-sand/80 hover:text-sunny transition-colors">{l.label}</Link></li>
      ))}
      {extra}
    </ul>
  </div>
);

const Legal = () => {
  const { settings: s } = useStore();
  const parts = [s?.legal_entity, s?.abn && `ABN ${s.abn}`, s?.business_address, s?.brand_email || "hello@grandpafinns.com"].filter(Boolean);
  if (!parts.length) return null;
  return <p data-testid="footer-legal-details">{parts.join(" · ")}</p>;
};

export const Footer = () => (
  <footer className="bg-navy text-sand mt-auto">
    <div className="container-gf pt-16 pb-10">
      <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <p className="font-display text-3xl md:text-4xl text-sand">Grandpa knew.</p>
          <p className="mt-4 text-sand/70 max-w-sm">Omega-3 Fish Oil and a Daily Multivitamin for people who'd rather be surfing.</p>
          <SocialLinks className="mt-6" />
          <div data-testid="footer-signup" className="mt-8 max-w-sm">
            <p className="font-display text-xl text-sand">Get 10% off your first order</p>
            <p className="mt-1 mb-3 text-sm text-sand/70">Join the Grandpa Finn's list for new arrivals and offers.</p>
            <WelcomeSignup source="footer" testPrefix="footer-signup" dark />
          </div>
        </div>
        <Col title="Explore" links={[...NAV, { to: "/quiz", label: "Take the quiz" }]} />
        <Col title="The fine print" links={POLICY_LINKS} extra={<li><button type="button" data-testid="footer-cookie-settings" onClick={openCookieSettings} className="text-sand/80 hover:text-sunny transition-colors">Cookie settings</button></li>} />
      </div>
      <div data-testid="fda-disclaimer" className="mt-12 rounded-2xl bg-white/5 p-5 text-sm text-sand/85">
        <span className="font-bold">*</span>{FDA}
      </div>
      <div className="mt-6 space-y-1 text-xs text-sand/50">
        <Legal />
        <p>© {new Date().getFullYear()} Grandpa Finn's. All rights reserved.</p>
      </div>
    </div>
  </footer>
);
